import BaseTextInputEditor from '../BaseTextInputEditor';

export class DateInputEditor extends BaseTextInputEditor {
  getCellCustomStyle(): string {
    return 'custom-date-editor';
  }
}
